import Star from '../assets/star.svg?react'
import Flag from '../assets/flag.svg?react'
import FlagFill from '../assets/flag_fill.svg?react'
import Thumbsup from '../assets/thumbsup.svg?react'
import ThumbsupFill from '../assets/thumbsup_fill.svg?react'
import Reply from '../assets/reply.svg?react'
import ReplyFill from '../assets/reply_fill.svg?react'

interface IReviewCardProps {
  username: string
  rating: number
  reviewText: string
  date: string
  likesCount: number
  isLiked: boolean
  isOwnReview: boolean
  onLike?: () => void
  onReply?: () => void
  onReport?: () => void
}

export const ReviewCard = (props: IReviewCardProps) => {
  return (
    <div className={'bg-white md:p-8 p-5 md:mb-6 mb-4'}>
      {/* Header with username and date */}
      <div className={'flex items-start justify-between md:mb-4 mb-3'}>
        <h3 className={'md:text-xl text-lg font-semibold'}>{props.username}</h3>
        <span className={'md:text-sm text-xs text-gray-500'}>{props.date}</span>
      </div>

      {/* Star rating */}
      <div className={'flex gap-1 md:mb-4 mb-3'}>
        {Array.from({ length: 5 }).map((_, index) => (
          <Star
            key={index}
            width={20}
            height={20}
            className={index < props.rating ? 'fill-yellow-400' : 'fill-gray-300'}
          />
        ))}
      </div>

      {/* Review text */}
      <p className={'md:text-base text-sm text-gray-700'}>{props.reviewText}</p>

      {/* Action buttons */}
      <div className={'flex items-center justify-between'}>
        <div className={`flex md:gap-4 gap-3 ${props.isOwnReview ? '' : 'md:mt-6 mt-4'}`}>
          {!props.isOwnReview && (
            <>
              <button
                onClick={props.onLike}
                className={`group flex items-center md:gap-2 gap-1.5 md:text-sm text-xs cursor-pointer transition-colors ${
                  props.isLiked 
                    ? 'text-primaryBlue' 
                    : 'text-subTitle hover:text-primaryBlue'
                }`}
              >
                {props.isLiked ? (
                  <ThumbsupFill width={16} height={16} className="fill-primaryBlue" />
                ) : (
                  <>
                    <Thumbsup width={16} height={16} className="group-hover:hidden fill-subTitle" />
                    <ThumbsupFill width={16} height={16} className="hidden group-hover:block fill-primaryBlue" />
                  </>
                )}
                <span>{props.isLiked ? 'Liked' : 'Like'}{props.likesCount > 0 ? ` (${props.likesCount})` : ''}</span>
              </button>

              <button
                onClick={props.onReply}
                className={
                  'group flex items-center md:gap-2 gap-1.5 md:text-sm text-xs text-subTitle hover:text-black cursor-pointer transition-colors'
                }
              >
                <Reply width={16} height={16} className="group-hover:hidden fill-subTitle" />
                <ReplyFill width={16} height={16} className="hidden group-hover:block fill-black" />
                <span>Reply</span>
              </button>
            </>
          )}
        </div>

        {!props.isOwnReview && (
          <button
            onClick={props.onReport}
            className={
              'group flex items-center md:gap-2 gap-1.5 md:mt-6 mt-4 md:text-sm text-xs text-subTitle hover:text-error cursor-pointer transition-colors'
            }
          >
            <Flag width={16} height={16} className="group-hover:hidden fill-subTitle" />
            <FlagFill width={16} height={16} className="hidden group-hover:block fill-error" />
            <span>Report</span>
          </button>
        )}
      </div>
    </div>
  )
}
